import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Card, Row, Col } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import moment from 'moment';
import { currencyConverter } from "../../utils";

export default function MutationDetail() {
   const navigate = useNavigate();
   const { id } = useParams();
   const [mutationData, setMutationData] = useState([]);
  const dataUser = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   transaction.actions.get_mutation(id).then((res)=>{
      setMutationData(res?.data);
      setLoading(false);
   });
  },[])

  return (
   <div className="bg-gray vh-100">
      <div className="fixed-top header bg-gray">
         <div className="text-center fw-semibold">
            Detail Mutasi
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>

      <div className="pt-5 pb-2 mx-4 mt-5 border-bottom">
         <table className="table-listed">
            <tbody>
               <tr>
                  <td className="text-secondary" width="130px">Bank</td>
                  <td className="text-dark fw-semibold">{mutationData?.partner?.name}</td>
               </tr>
               <tr>
                  <td className="text-secondary" width="130px">Nasabah</td>
                  <td className="text-dark fw-semibold">{dataUser?.name}</td>
               </tr>
               {/* <tr>
                  <td className="text-secondary">No.Anggota</td>
                  <td className="text-dark fw-semibold">
                     {dataUser?.id}/
                     <span>{moment(new Date(dataUser?.created_at)).format('MMMM YYYY')}</span>
                  </td>
               </tr>
               <tr>
                  <td className="text-secondary">Tanggal Terdaftar</td>
                  <td className="text-dark fw-semibold">{}</td>
               </tr> */}
            </tbody>
         </table>
      </div>
      
      <div className="p-4">
         <Card className="mb-3 border-0 btn-radius d-grid box-shadow">
            <Card.Body>
               <Row>
                  <Col>
                     <small className="ts-xs text-secondary">Total Saldo</small>
                     <h5 className={"text-success " + (loading ? 'skeleton':'')}>
                        {!loading && currencyConverter(Number(mutationData?.summary?.total_debit) - mutationData?.summary?.total_credit)}
                     </h5>
                  </Col>
                  <Col>
                     <small className="ts-xs text-secondary">Total Sampah Terkumpul</small>
                     <h5 className={"text-success " + (loading ? 'skeleton':'')}>
                        {!loading && (mutationData?.summary?.total_weight + ' Kg')}
                     </h5>
                  </Col>
               </Row>
            </Card.Body>
         </Card>
         <Card className="mb-3 border-0 btn-radius d-grid box-shadow">
            <Card.Body>
               <Row>
                  <Col>
                     <small className="ts-xs text-secondary">Total Debit</small>
                     <h5 className={"text-success " + (loading ? 'skeleton':'')}>{!loading && currencyConverter(mutationData?.summary?.total_debit)}</h5>
                  </Col>
                  <Col>
                     <small className="ts-xs text-secondary">Total Kredit</small>
                     <h5 className={"text-success " + (loading ? 'skeleton':'')}>{!loading && currencyConverter(mutationData?.summary?.total_credit)}</h5>
                  </Col>
               </Row>
            </Card.Body>
         </Card>
      </div>

      <div className="d-grid gap-2 fixed-bottom p-4">
         <Button className="btn-auth rounded-pill p-3" variant="success" onClick={() => navigate(`/mutation/${id}/history`)}>
            CEK RIWAYAT TRANSAKSI
         </Button>
         <Button className="btn-auth rounded-pill p-3" variant="outline-success">
            BANTUAN
         </Button>
      </div>
   </div>
  );
}